<template>
  <div>
    <vx-card v-show="showImportWidget">
      <div class="text-center pb-8">
        <h4 class="pb-2">You Are importing accounts using Machine Learning</h4>
        <p class="text-dark-grey">
          This will upload your account list and match them against any accounts
          currently in the database.After it will upload your account from the
          submitted document to the database.
        </p>
      </div>
      <div class="mb-8">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Import File Name:</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              class="w-full"
              name="file_name"
              v-model="file_name"
              v-validate="'required'"
              data-vv-as="File Name"
            />
          </div>
          <span
            class="text-danger text-sm mt-2 ml-16"
            v-show="errors.has('file_name')"
            >{{ errors.first("file_name") }}
          </span>
          <span
            class="text-danger text-sm mt-2 ml-16"
            v-show="table_name_exists"
            >{{ table_name_exists }}
          </span>
        </div>
        <div class="center-span  mb-5">
          <span class="text-danger mt-5">{{ upload_validation_message }}</span>
        </div>

        <import-excel
          ref="importExcel"
          :onSuccess="loadDataInTable"
          :purpose="'enhanced_machine_learning'"
          @created-csv-filename="getCsvFileName"
        />
        <div class="center-span">
          <vs-button class="mt-10" @click.prevent="submitForm"
            >Submit</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card
      title="Now You Need To Select Fields To The Table"
      class="mt-5"
      v-if="showFieldComparision"
    >
      <p>
        On the left are the fields from the file you have uploaded. On the right
        are the fields from our account table and fields.
      </p>

      <!-- <vs-progress  color="primary"></vs-progress>
      <p class="text-center mt-5">
        Please Wait Your Field Matching and Data is Being Processed
      </p> -->
      <div class="vx-row p-10">
        <div class="vx-col w-full md:w-1/3">

          <vs-list>
            <vs-list-header
              title="Database Fields"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <v-select
                    @input="setSelected"
                    class="pb-15 pt-15"
                    :options="database_fields"
                    v-model="slot.dbfield"
                    style="height:120px;"
                  />
                 
                </div>
                <div class="vx-col w-full md:w-1/6">
                  <vs-icon size="18px" 
                  class="cursor-pointer mt-3"
                  @click="deleteColumn(slot)"
                  color="danger"
                  icon="delete"
                  :key="index + 1"
                ></vs-icon>
                </div>
              </div>
            </template>
             <span class="text-danger text-sm mb-10">{{
              validation_message
            }}</span>
            
          </vs-list>
         
        </div>
        <div class="vx-col w-full md:w-1/3">
          <vs-list>
            <vs-list-header
              title="Uploaded Fields"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <!-- <v-select
                v-if="slot.dbfield != 'address'"
                class="pb-10 pt-10"
                label="Company"
                :options="uploaded_csv_fields"
                :key="index"
                v-model="slot.uploadfield"
              /> -->
              <v-select
                label="field_name"
                class="pb-15 pt-15"
                :options="uploaded_csv_fields"
                :key="index"
                v-model="slot.uploadfield"
                style="height:120px;"
              />
            </template>
          </vs-list>
          
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            @click="addAnother"
            >Add another column</vs-button
          >
          
         
        </div>
        <div class="vx-col w-full md:w-1/3">
          <h6>Note :</h6>
          <p class="text-dark-grey mt-2">
            1. Fields should not be empty.
          </p>
          <p class="text-dark-grey">
            2. Account required fields should be selected. <br>
          <p class="text-dark-grey ml-10">
            &#x2022; Company Name
          </p>
          <p class="text-dark-grey ml-10">
            &#x2022; Company Registration Number
          </p>
          <p class="text-dark-grey ml-10">
            &#x2022; Registered Office Country
          </p>
          <p class="text-dark-grey ml-10">
            &#x2022; Status
          </p>

          </p>
          <p class="text-dark-grey">
            3. If phone is selected, then its phone type and phone code should be selected.
          </p>
          <p class="text-dark-grey">
            4. If revenue is selected, then its currency code should be selected.
          </p>
          <p class="text-dark-grey">
            5. If switchboard is selected, then its switchboard phone code should be selected.
          </p>
          <p class="text-dark-grey">
            6. If site switchboard is selected, then its site switchboard phone code should be selected.
          </p>
          <div class="p-10">
            <vs-button
            @click="alterColumnNames"
            color="primary"
            type="filled"
            style="float:right;"
            >Proceed</vs-button>         
           </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import ImportExcel from "@/components/excel/ImportExcel.vue";
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    ImportExcel,
    Prism,
    vSelect
  },
  data() {
    return {
      master_fields: [],
      client_fields: [],
      campaign_fields: [],
      csv_table_columns: [],
      selected_db_fields: [],
      abilities: null,
      table_name_exists: null,
      upload_validation: false,
      upload_validation_message: null,
      file_name: null,
      table_name: null,
      csv_filename: null,
      validation_message: "",
      fieldgroups: [
        {
          dbfield: "",
          count: 0,
          uploadfield: "",
          selection: true
        }
      ],
      showFieldComparision: false,
      showImportWidget: true,
      tableData: [],
      header: [],
      sheetName: "",
      uploaded_csv_fields: [],
      uploaded_columns: [],
      database_fields: [
        {
          id: 1,
          name: "company_name",
          value: "company_name",
          label: "Company Name",
          selection: true
        },
        {
          id: 2,
          name: "company_registration_number",
          value: "company_registration_number",
          label: "Company Registration Number",
          selection: true
        },
        {
          id: 3,
          name: "registered_office_country",
          value: "registered_office_country",
          selection: true,
          label: "Registered Office Country"
        },
        {
          id: 4,
          name: "status",
          value: "status",
          selection: true,
          label: "Status"
        },
        {
          id: 5,
          name: "head_office_country",
          value: "head_office_country",
          label: "Head Office Country",
          selection: true
        },
        {
          id: 6,
          name: "head_office_address_1",
          value: "head_office_address_1",
          selection: true,
          label: "Head Office Address 1"
        },
        {
          id: 7,
          name: "head_office_city",
          value: "head_office_city",
          selection: true,
          label: "Head Office City"
        },
       
        {
          id: 8,
          name: "switchboard",
          value: "switchboard",
          selection: true,
          label: "Switchboard"
        },
        {
          id: 9,
          name: "website",
          value: "website",
          selection: true,
          label: "Website"
        },
        {
          id: 10,
          name: "linkedin",
          value: "linkedin",
          selection: true,
          label: "Social Media"
        },
        {
          id: 11,
          name: "company_category",
          value: "company_category",
          selection: true,
          label: "Company Category"
        },

        {
          id: 12,
          name: "head_office_address_2",
          value: "head_office_address_2",
          selection: true,
          label: "Head Office Address 2"
        },
        {
          id: 13,
          name: "head_office_address_3",
          value: "head_office_address_3",
          selection: true,
          label: "Head Office Address 3"
        },
        {
          id: 14,
          name: "head_office_county",
          value: "head_office_county",
          selection: true,
          label: "Head Office County"
        },
        {
          id: 15,
          name: "head_office_postcode",
          value: "head_office_postcode",
          selection: true,
          label: "Head Office Postcode"
        },
        {
          id: 16,
          name: "registered_office_address_1",
          value: "registered_office_address_1",
          selection: true,
          label: "Registered Office Address 1"
        },
        {
          id: 17,
          name: "registered_office_address_2",
          value: "registered_office_address_2",
          selection: true,
          label: "Registered Office Address 2"
        },
        {
          id: 18,
          name: "registered_office_address_3",
          value: "registered_office_address_3",
          selection: true,
          label: "Registered Office Address 3"
        },
        {
          id: 19,
          name: "registered_office_city",
          value: "registered_office_city",
          selection: true,
          label: "Registered Office City"
        },
        {
          id: 20,
          name: "registered_office_county",
          value: "registered_office_county",
          selection: true,
          label: "Registered Office County"
        },
        {
          id: 21,
          name: "registered_office_postcode",
          value: "registered_office_postcode",
          selection: true,
          label: "Registered Office Postcode"
        },
        {
          id: 22,
          name: "phone",
          value: "phone",
          selection: true,
          label: "Phone No."
        },
        {
          id: 23,
          name: "phone_type",
          value: "phone_type",
          selection: true,
          label: "Phone Type"
        },
        {
          id: 30,
          name: "phone_code",
          value: "phone_code",
          selection: true,
          label: "Phone Code"
        },
        {
          id: 24,
          name: "sic_code",
          value: "sic_code",
          selection: true,
          label: "SIC Code"
        },
        {
          id: 25,
          name: "revenue",
          value: "revenue",
          selection: true,
          label: "Revenue"
        },
        {
          id: 26,
          name: "currency_code",
          value: "currency_code",
          selection: true,
          label: "Currency Code"
        },
        {
          id: 27,
          name: "no_of_employees",
          value: "no_of_employees",
          selection: true,
          label: "No of Employee"
        },
        {
          id: 28,
          name: "registration_jurisdiction",
          value: "registration_jurisdiction",
          selection: true,
          label: "Registration Jurisdiction"
        },
        {
          id: 29,
          name: "vertical",
          value: "vertical",
          selection: true,
          label: "Vertical"
        },
        {
          id: 31,
          name: "switchboard_phone_code",
          value: "switchboard_phone_code",
          selection: true,
          label: "Switchboard Phone Code"
        },
        {
          id: 32,
          name: "site_switchboard_phone_code",
          value: "site_switchboard_phone_code",
          selection: true,
          label: "Site Switchboard Phone Code"
        },
        {
          id: 33,
          name: "site_switchboard",
          value: "site_switchboard",
          selection: true,
          label: "Site Switchboard"
        }
      ]
    };
  },
  mounted() {
    this.getMasterFields();
    // console.log(this.selected)
  },
  watch: {},
  methods: {
    validatetUserUploaded() {
      let data = {};
      this.file_name=this.file_name.replace(/ /g,"_");
      data.table_name = this.file_name.replace(/\s+/g, "_").toLowerCase();
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/get_user_uploaded_table_name",
          data
        )
        .then(response => {
          if (response.data === undefined || response.data.length == 0) {
            this.table_name_exists = null;
            if (this.upload_validation == true) {
              this.importCsvDataToTable();
              this.upload_validation_message = null;
              this.showImportWidget = false;
              this.showFieldComparision = true;
              this.$vs.loading.close();
            } else {
              this.upload_validation_message = "Please upload a file";
            }
          } else {
            this.table_name_exists =
              "File name already exists. Please try another";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    finishedSelected() {
      this.$router.push({
        name: "enhanceaccountmachinelearningRemainder",
        params: { tableId: "ml_" + this.file_name }
      });
    },
    setSelected(field) {
      // this.database_fields = this.database_fields.filter(function(el) {
      //   return el.name != field.name;
      // });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    addAnother: function() {
      this.fieldgroups.push({
        dbfield: "",
        uploadfield: "",
        count: ++this.count
      });
    },
    deleteColumn(slot) {
      console.log(this.fieldgroups);
      this.fieldgroups = this.fieldgroups.filter(function(ele) {
        return ele != slot;
      });
      console.log(slot);
      // this.fieldgroups.pop(slot);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.validatetUserUploaded();
        }
      });
    },
    importCsvDataToTable() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let ObjData = {};
      ObjData.csv_filename = this.csv_filename;
      this.file_name=this.file_name.replace(/ /g,"_");
      this.file_name = this.file_name.replace(/\s+/g, "_").toLowerCase();
      ObjData.table_name = this.file_name;
      ObjData.user_info = userInfo;

      let self = this;

      // this.$vs.loading();
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/import_csv_data_to_table",
          ObjData
        )
        .then(response => {
          if (response.data.status == "success") {
            this.showImportWidget = false;
            this.showFieldComparision = true;
          } else {
            // console.log(response);
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getMasterFields() {
      let self = this;
      let level = 'account'
      axios
        .get(this.$base_url + "/api/enhanced_accounts/get_master_fields/" + level)
        .then(response => {
          if (response) {
            this.master_fields = response.data;

            this.master_fields.forEach(function(ele, index) {
              ele.id = self.database_fields.length + index + 1;
              ele.label = ele.name;
              ele.selection = true;
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });
            Array.prototype.push.apply(
              this.database_fields,
              this.master_fields
            );
            console.log(this.database_fields);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    alterColumnNames() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.fieldgroups[0].csv_filename = this.csv_filename;
      this.file_name=this.file_name.replace(/ /g,"_");
      this.file_name = this.file_name.replace(/\s+/g, "_").toLowerCase();
      this.fieldgroups[0].table_name = this.file_name;
      this.fieldgroups[0].user_info = userInfo;
      let self = this;
      let fields_result = this.fieldgroups.map(({ dbfield }) => dbfield);
      fields_result.forEach(function(ele) {
        self.selected_db_fields.push(ele.name);
      });

      this.$vs.loading();
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/alter_column_names",
          this.fieldgroups
        )
        .then(response => {
          if (response.data.status == "success") {

            let selected_fields = []
            this.fieldgroups.forEach(function(ele){

              if(ele){

                selected_fields.push('enh_' + ele.dbfield.name)
              }

              
            })

            let table_name = btoa('ml_' + this.file_name)
            this.$router.push({ name: 'enhanceaccountmachinelearning', params: { table: table_name } })
          } else if (response.data.status == "not_empty") {
            this.validation_message = response.data.message;
            console.log(response.data.message);
          } else if (response.data.status == "phone_and_phone_type") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "switchboard_and_switchboard_phone_code") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "site_switchboard_and_site_switchboard_phone_code") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "revenue_and_currency_code_key") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          }
          else if (response.data.status == "reg_no_or_country") {
            this.validation_message = response.data.message;
          } 
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadDataInTable({ header }) {
      header.map(function(el) {
        var o = Object.assign({}, el);
        o.name = el;
        return o;
      });
      this.uploaded_csv_fields = header;

      console.log("uploaded csv fields", this.uploaded_csv_fields);
      //  this.showImportWidget = false;
      //       this.showFieldComparision = true;
      this.$vs.loading.close();
      this.upload_validation = true;
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    getCsvFileName(value) {
      this.csv_filename = value;
      // this.table_name = this.csv_filename.replace(/\.[^.$]+$/, '');
    }
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.center-span {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
